module.exports = __webpack_public_path__ + "static/media/notification.ca75315f.svg";